import * as React from "react";
const SvgFlag = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("mask", { id: "mask0_54775_65726", style: {
  maskType: "luminance"
}, maskUnits: "userSpaceOnUse", x: 0, y: 0, width: 24, height: 24 }, /* @__PURE__ */ React.createElement("rect", { width: 24, height: 24, fill: "white" })), /* @__PURE__ */ React.createElement("g", { mask: "url(#mask0_54775_65726)" }, /* @__PURE__ */ React.createElement("path", { d: "M5 21V4H14L14.4 6H20V16H13L12.6 14H7V21H5Z", fill: "#5F5C71" })));
export default SvgFlag;
